import React from "react";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import FilterBar from "./FilterBar";
import DiscountLineChart from "./DiscountLineChart";

const TrendView = () => {
  const updatesLoading = useSelector((state) => state.discounts.updatesLoading);

  return (
    <div>
      <FilterBar />

      <div data-testid="trend-chart-container" className="chart-root">
        {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <DiscountLineChart />}
      </div>
    </div>
  );
};

export default TrendView;
